// import React from 'react';
// import { Container, Row, Col, Button } from 'react-bootstrap';
// import './footer.css';
// import AusFlag from '../../images/Australian-flag.svg';
// import USAFlag from '../../images/American-flag.svg';
// import IndianFlag from '../../images/Indian-flag.svg';
// import linkedin from '../../images/linkedin.svg';
// import facebook from '../../images/fb.svg';
// import instagram from '../../images/instagram.svg';
// import youtube from '../../images/youtube.svg';

// const year = new Date().getFullYear();

// function Footer() {
//     return (
//         <footer className="footer">
//             <Container fluid>
//                 {/* Global Presence */}
//                 <Row className="footer-addresses">
//                     <Col xs="12" md="6" className="pb-3 pb-lg-0">
//                         <Row className="gap-3 gap-lg-0">
//                             <Col xs="12" className="text-center text-lg-start">
//                                 <p className="mb-4 ft-wt-600 block-title">Global Presence</p>
//                             </Col>
//                             <Col xs="12" xl="6">
//                                 <div className="address-item">
//                                     <div className="flag-circle">
//                                         <img src={USAFlag} alt="USA Flag" loading="lazy" />
//                                     </div>
//                                     <div className="address-info">
//                                         <p className="ft-wt-500">ACube USA LLC</p>
//                                         <h6>
//                                             401 Ryland St. STE 200-A,<br /> Reno, WASHOE COUNTY,<br /> NV 89502 USA
//                                         </h6>
//                                     </div>
//                                 </div>
//                             </Col>
//                             <Col xs="12" xl="6">
//                                 <div className="address-item">
//                                     <div className="flag-circle">
//                                         <img src={AusFlag} alt="Aus Flag" loading="lazy" />
//                                     </div>
//                                     <div className="address-info">
//                                         <p className="ft-wt-500">Australia</p>
//                                         <h6>
//                                             ACubetech solutions<br />
//                                             Engenesis Level 14,<br />
//                                             275 Alfred Street North Sydney,<br />
//                                             New South Wales 2060<br />
//                                             Australia 02 91880844
//                                         </h6>
//                                     </div>
//                                 </div>
//                             </Col>
//                         </Row>
//                     </Col>

//                     {/* India Offices */}
//                     <Col xs="12" md="6" className="mt-4 mt-md-0 pb-3 pb-lg-0">
//                         <Row className="gap-3 gap-lg-0">
//                             <Col xs="12" className="text-center text-lg-start">
//                                 <p className="mb-4 ft-wt-600 block-title">Offices and Development Centers</p>
//                             </Col>
//                             <Col xs="12" xl="6">
//                                 <div className="address-item">
//                                     <div className="flag-circle">
//                                         <img src={IndianFlag} alt="India Flag" loading="lazy" />
//                                     </div>
//                                     <div className="address-info">
//                                         <p className="ft-wt-500">Bangalore</p>
//                                         <h6>
//                                             ACubetech solutions Pvt Ltd<br />
//                                             Brigade IRV, 3rd Floor.<br />
//                                             Nallurhalli, Whitefield,<br />
//                                             Bangalore - 560066, India.
//                                         </h6>
//                                     </div>
//                                 </div>
//                             </Col>
//                             <Col xs="12" xl="6">
//                                 <div className="address-item">
//                                     <div className="flag-circle">
//                                         <img src={IndianFlag} alt="India Flag" loading="lazy" />
//                                     </div>
//                                     <div className="address-info">
//                                         <p className="ft-wt-500">Chennai</p>
//                                         <h6>
//                                             ACubetech solutions Pvt Ltd<br />
//                                             Akshaya CUBE, 6th Floor.<br />
//                                             OMR Thoraipakkam, Near BSR Mall,<br />
//                                             Chennai - 600096, India.
//                                         </h6>
//                                     </div>
//                                 </div>
//                             </Col>
//                         </Row>
//                     </Col>
//                 </Row>

//                 {/* On-Call Support */}
//                 <Row className="gap-3 gap-lg-0">
//                     <Col xs="12" className="text-center text-lg-start">
//                         <p className="mb-4 ft-wt-600 block-title">On-Call Support</p>
//                     </Col>
//                     <Col xs="12" lg="8" xl="10">
//                         <Row className="gap-3 gap-xl-0">
//                             <Col xs="12" xl="4">
//                                 <div className="d-flex align-items-center gap-3 justify-content-lg-start h-100">
//                                     <div className="flag-circle">
//                                         <img src={USAFlag} alt="USA Flag" loading="lazy" />
//                                     </div>
//                                     <div className="address-info">
//                                         <a href="tel:+17027602845"><h4>+1 (702) 760-2845</h4></a>
//                                     </div>
//                                 </div>
//                             </Col>
//                             <Col xs="12" xl="6">
//                                 <div className="d-flex align-items-center gap-3 justify-content-lg-start w-100">
//                                     <div className="flag-circle mb-3 mb-lg-0">
//                                         <img src={IndianFlag} alt="India Flag" loading="lazy" />
//                                     </div>
//                                     <div className="address-info w-100">
//                                         <div className="d-flex align-items-center gap-3 mb-4 w-100 flex-wrap">
//                                             <p className="ft-wt-600 mb-0" style={{ maxWidth: "120px", width: "100%" }}>Sales Team:</p>
//                                             <a href="tel:+9197899150871"><h4 className="mb-0">+91 7899 150 871</h4></a>
//                                         </div>
//                                         <div className="d-flex align-items-center gap-3 mb-0 w-100 flex-wrap">
//                                             <p className="ft-wt-600 mb-0" style={{ maxWidth: "120px", width: "100%" }}>HR Team:</p>
//                                             <a href="tel:+919686077111"><h4 className="mb-0">+91 9686 077 111</h4></a>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </Col>
//                         </Row>
//                     </Col>
//                 </Row>

//                 <hr className="footer-divider" />

//                 {/* Footer Bottom */}
//                 <Row className="footer-bottom align-items-center gap-4 gap-lg-0">
//                     <Col xs="12" lg="3">
//                         <div className="social-icons justify-content-center justify-content-lg-start">
//                             <a href="https://www.linkedin.com/company/acubetech-solutions-private-limited/mycompany/?viewAsMember=true" rel="noreferrer" target="_blank" className="social-icon">
//                                 <img src={linkedin} alt="linkedin" loading="lazy" />
//                             </a>
//                             <a href="https://www.instagram.com/acubetech/" className="social-icon" rel="noreferrer" target="_blank">
//                                 <img src={instagram} alt="instagram" loading="lazy" />
//                             </a>
//                             <a href="https://www.youtube.com/@acubetechnologies" className="social-icon" rel="noreferrer" target="_blank">
//                                 <img src={youtube} alt="youtube" loading="lazy" />
//                             </a>
//                             <a href="https://www.facebook.com/Acubetech/" className="social-icon" rel="noreferrer" target="_blank">
//                                 <img src={facebook} alt="facebook" loading="lazy" />
//                             </a>
//                         </div>
//                     </Col>
//                     <Col xs="12" lg="6" className="text-center">
//                         <h6 className="mb-0 ft-wt-500 opacity-70">
//                             Copyright © {year} Acube. All Rights Reserved. <span><a className='text-decoration-underline text-white' style={{ fontSize: "16px" }} href="https://acubetechnologies.com/privacy-policy" rel="noreferrer" target="_blank">Privacy Policy</a></span>
//                         </h6>
//                     </Col>
//                     <Col xs="12" lg="3" className="text-center text-lg-end">
//                         {/* ✅ Fixed brochure link */}
//                         <a href="/Acube-brochure.pdf" download>
//                             <Button variant="secondary" className="text-uppercase" style={{ fontSize: "16px" }}>Download Brochure</Button>
//                         </a>
//                     </Col>
//                 </Row>
//             </Container>
//         </footer>
//     );
// }

// export default Footer;



import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import './footer.css';

// Assets
import AusFlag from '../../images/Australian-flag.svg';
import USAFlag from '../../images/American-flag.svg';
import IndianFlag from '../../images/Indian-flag.svg';
import linkedin from '../../images/linkedin.svg';
import facebook from '../../images/fb.svg';
import instagram from '../../images/instagram.svg';
import youtube from '../../images/youtube.svg';

const year = new Date().getFullYear();

const Footer = () => {
    return (
        <>
            <style>{`
                .premium-footer {
                    background-color: #020617; /* Deep midnight slate */
                    color: #f8fafc;
                    padding-top: 5rem;
                    font-family: inherit;
                }

                /* --- Typography --- */
                .footer-label {
                    color: #38bdf8; /* Premium cyan accent */
                    font-size: 0.75rem;
                    font-weight: 700;
                    letter-spacing: 0.1em;
                    text-transform: uppercase;
                    margin-bottom: 1.5rem;
                }

                .office-title {
                    font-size: 1.1rem;
                    font-weight: 600;
                    color: #ffffff;
                    margin-bottom: 0.75rem;
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                }

                .office-flag {
                    width: 20px;
                    height: 20px;
                    object-fit: cover;
                    border-radius: 50%;
                }

                .address-text {
                    font-size: 0.9rem;
                    color: #94a3b8;
                    line-height: 1.6;
                    margin-bottom: 0;
                }

                /* --- Interactions --- */
                .footer-link {
                    color: #e2e8f0;
                    text-decoration: none;
                    transition: color 0.2s ease;
                }

                .footer-link:hover {
                    color: #38bdf8;
                }

                .phone-link {
                    font-size: 1.1rem;
                    font-weight: 600;
                    color: #ffffff;
                    text-decoration: none;
                    transition: color 0.2s ease;
                }

                .phone-link:hover {
                    color: #38bdf8;
                }

                /* --- Social Icons --- */
                .social-icon-link {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    background-color: rgba(255, 255, 255, 0.05);
                    transition: all 0.3s ease;
                }

                .social-icon-link img {
                    width: 18px;
                    height: 18px;
                    // filter: brightness(0) invert(1) opacity(0.7);
                    transition: all 0.3s ease;
                }

                .social-icon-link:hover {
                    background-color: rgba(255, 255, 255, 0.1);
                    transform: translateY(-3px);
                }

                // .social-icon-link:hover img {
                //     filter: brightness(0) invert(1) opacity(1);
                // }

                /* --- Dividers --- */
                .footer-divider {
                    border-color: rgba(255, 255, 255, 0.1);
                    margin: 3rem 0;
                }
            `}</style>

            <footer className="premium-footer">
                <Container fluid="lg">

                    {/* --- TOP ROW: Global Addresses --- */}
                    <Row className="g-4">
                        {/* Global Presence Section */}
                        <Col xs={12} lg={6}>
                            <div className="footer-label">Global Presence</div>
                            <Row className="g-4">
                                <Col xs={12} sm={6}>
                                    <h4 className="office-title">
                                        <img src={USAFlag} alt="USA" loading="lazy" className="office-flag" />
                                        ACube USA LLC
                                    </h4>
                                    <p className="address-text">
                                        401 Ryland St. STE 200-A,<br />
                                        Reno, Washoe County,<br />
                                        NV 89502, USA
                                    </p>
                                </Col>
                                <Col xs={12} sm={6}>
                                    <h4 className="office-title">
                                        <img src={AusFlag} alt="Australia" loading="lazy" className="office-flag" />
                                        Australia
                                    </h4>
                                    <p className="address-text">
                                        ACubetech Solutions<br />
                                        Engenesis Level 14,<br />
                                        275 Alfred Street North Sydney,<br />
                                        NSW 2060, Australia
                                    </p>
                                </Col>
                            </Row>
                        </Col>

                        {/* Development Centers Section */}
                        <Col xs={12} lg={6}>
                            <div className="footer-label">Development Centers</div>
                            <Row className="g-4">
                                <Col xs={12} sm={6}>
                                    <h4 className="office-title">
                                        <img src={IndianFlag} alt="India" loading="lazy" className="office-flag" />
                                        Bangalore
                                    </h4>
                                    <p className="address-text">
                                        ACubetech Solutions Pvt Ltd<br />
                                        Brigade IRV, 3rd Floor.<br />
                                        Nallurhalli, Whitefield,<br />
                                        Bangalore - 560066, India.
                                    </p>
                                </Col>
                                <Col xs={12} sm={6}>
                                    <h4 className="office-title">
                                        <img src={IndianFlag} alt="India" loading="lazy" className="office-flag" />
                                        Chennai
                                    </h4>
                                    <p className="address-text">
                                        ACubetech Solutions Pvt Ltd<br />
                                        Akshaya CUBE, 6th Floor.<br />
                                        OMR Thoraipakkam, Near BSR Mall,<br />
                                        Chennai - 600096, India.
                                    </p>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                    <hr className="footer-divider" />

                    {/* --- MIDDLE ROW: Direct Support --- */}
                    <Row className="g-4 align-items-center">
                        <Col xs={12} md={4} lg={3}>
                            <div className="footer-label mb-2">USA Support</div>
                            <a href="tel:+17027602845" className="phone-link">+1 (702) 760-2845</a>
                        </Col>
                        <Col xs={12} md={4} lg={3}>
                            <div className="footer-label mb-2">Sales Team (India)</div>
                            <a href="tel:+9197899150871" className="phone-link">+91 7899 150 871</a>
                        </Col>
                        <Col xs={12} md={4} lg={3}>
                            <div className="footer-label mb-2">HR Team (India)</div>
                            <a href="tel:+919686077111" className="phone-link">+91 9686 077 111</a>
                        </Col>
                        <Col xs={12} lg={3} className="text-lg-end mt-4 mt-lg-0">
                            <a href="/Acube-brochure.pdf" download tabIndex="-1">
                                <Button variant="outline-light" className="rounded-pill px-4 py-2 text-uppercase fw-semibold" style={{ fontSize: "0.85rem" }}>
                                    Download Brochure
                                </Button>
                            </a>
                        </Col>
                    </Row>

                    <hr className="footer-divider" />

                    {/* --- BOTTOM ROW: Legal & Socials --- */}
                    <Row className="align-items-center pb-4 g-3">
                        <Col xs={12} md={4} className="order-2 order-md-1 text-center text-md-start">
                            <p className="address-text" style={{ fontSize: "0.85rem" }}>
                                Copyright © {year} ACube. All Rights Reserved.
                            </p>
                        </Col>

                        <Col xs={12} md={4} className="order-3 order-md-3 text-center">
                            <a href="https://acubetechnologies.com/privacy-policy" rel="noreferrer" target="_blank" className="footer-link" style={{ fontSize: "0.85rem" }}>
                                Privacy Policy
                            </a>
                        </Col>

                        <Col xs={12} md={4} className="order-1 order-md-2">
                            <div className="d-flex gap-3 justify-content-center">
                                <a href="https://www.linkedin.com/company/acubetech-solutions-private-limited/" rel="noreferrer" target="_blank" className="social-icon-link" aria-label="LinkedIn">
                                    <img src={linkedin} alt="" loading="lazy" />
                                </a>
                                <a href="https://www.instagram.com/acubetech/" rel="noreferrer" target="_blank" className="social-icon-link" aria-label="Instagram">
                                    <img src={instagram} alt="" loading="lazy" />
                                </a>
                                <a href="https://www.youtube.com/@acubetechnologies" rel="noreferrer" target="_blank" className="social-icon-link" aria-label="YouTube">
                                    <img src={youtube} alt="" loading="lazy" />
                                </a>
                                <a href="https://www.facebook.com/Acubetech/" rel="noreferrer" target="_blank" className="social-icon-link" aria-label="Facebook">
                                    <img src={facebook} alt="" loading="lazy" />
                                </a>
                            </div>
                        </Col>
                    </Row>

                </Container>
            </footer>
        </>
    );
}

export default Footer;